import {Fragment} from 'react'
import dayjs from 'dayjs'
import {CheckCircleIcon} from '@/components/ui/icon/Icon'
import {useTranslation} from '@/translations/i18n'
import {BulkExportConfig} from '@/features/projects/siar-bulk-export/components/bulk-siar-export-dialog/BulkSiarExportConfigStep'
import {siarExportTypeToLabel} from '@/features/projects/siar-bulk-export/utils'
import {
    StyledBulkSiarExportCriteriaDivider,
    StyledBulkSiarExportCriteriaItem,
    StyledBulkSiarExportCriteriaSummary
} from '@/features/projects/siar-bulk-export/components/bulk-siar-export-dialog/style'

type BulkSiarExportCriteriaSummaryProps = {
    config: BulkExportConfig
}

const formatDate = (date: Date | null): string => (date ? dayjs(date).format('DD/MM/YYYY') : '—')

export const BulkSiarExportCriteriaSummary = ({config}: BulkSiarExportCriteriaSummaryProps) => {
    const {t} = useTranslation()

    const items: {label: string; value: React.ReactNode}[] = []

    if (config.exportType) {
        items.push({
            label: t('projects:bulk_siar_export_type_label'),
            value: t(siarExportTypeToLabel[config.exportType])
        })
    }

    if (config.dateFrom || config.dateTo) {
        items.push({
            label: t('projects:bulk_siar_export_column_period'),
            value: `${formatDate(config.dateFrom)} → ${formatDate(config.dateTo)}`
        })
    }

    if (config.addRegistry) {
        items.push({
            label: t('projects:bulk_siar_export_include_registry'),
            value: <CheckCircleIcon size={16} />
        })
    }

    if (items.length === 0) return null

    return (
        <StyledBulkSiarExportCriteriaSummary>
            {items.map((item, index) => (
                <Fragment key={item.label}>
                    {index > 0 && <StyledBulkSiarExportCriteriaDivider>•</StyledBulkSiarExportCriteriaDivider>}
                    <StyledBulkSiarExportCriteriaItem>
                        <span>{item.label}:</span>
                        <span>{item.value}</span>
                    </StyledBulkSiarExportCriteriaItem>
                </Fragment>
            ))}
        </StyledBulkSiarExportCriteriaSummary>
    )
}
